import gql from 'graphql-tag';
import Interface from '../Interface';
import { RoomObjectAclSchema } from '../../definitions/schemas';
import { ListingConnection, ListingInput } from '../Listing';

interface GetRoomObjectAclInput extends ListingInput {
  objectDataId?: string;
  objectDataType?: string;
  roomId: string;
}

interface GetRoomObjectAclData {
  roomObjectAcls: ListingConnection<RoomObjectAclSchema>;
}

export default class RoomObjectAclsInterface extends Interface {
  public async getRoomObjectAcls(variables: GetRoomObjectAclInput) {
    const response = await this.query<GetRoomObjectAclData>(
      () =>
        this.apolloService.executeQuery<GetRoomObjectAclData>({
          query: gql`
            query roomObjectAcls(
              $limit: Int!
              $objectDataId: ID
              $objectDataType: RoomObjectAclEnum
              $offset: Int
              $roomId: ID!
            ) {
              roomObjectAcls(
                limit: $limit
                objectDataId: $objectDataId
                objectDataType: $objectDataType
                offset: $offset
                roomId: $roomId
              ) {
                totalCount
                nodes {
                  id
                  guestId
                  guestType
                  objectDataId
                  objectDataType
                  guest {
                    id
                    avatarUri
                    email
                    firstName
                    lastName
                    phoneNumber
                    photo
                  }
                }
              }
            }
          `,
          variables,
        }),
      'Error loading room object acls',
      true
    );

    return response.roomObjectAcls;
  }
}
